import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionGalleryService = ( createDecorator('extensionGalleryService'));
const IExtensionManagementService = ( createDecorator('extensionManagementService'));
const IGlobalExtensionEnablementService = ( createDecorator('IGlobalExtensionEnablementService'));
const IExtensionTipsService = ( createDecorator('IExtensionTipsService'));
export { IExtensionGalleryService, IExtensionManagementService, IExtensionTipsService, IGlobalExtensionEnablementService };
